import { Box, Typography, Link } from '@mui/material';
import { HighLevelRequirementDetail } from 'src/graphql/generated';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import { format, parseISO } from 'date-fns';

type hlrDetailsKeyProps = {
  hlrCardDetails: HighLevelRequirementDetail;
};
const HLRContent = ({ hlrCardDetails }: hlrDetailsKeyProps) => {
  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Typography variant="h4">{hlrCardDetails?.activity_type_hlr_heading}</Typography>
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <HomeWorkIcon sx={{ fontSize: '14px', mr: 1.5 }} />
          {hlrCardDetails?.activity_type_hlr_specialist_college}
        </Typography>
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
          <CalendarTodayIcon sx={{ fontSize: '14px', mr: 1.5 }} />
          Due {hlrCardDetails && format(parseISO(hlrCardDetails?.end_date!), 'MMM yyyy')}
        </Typography>

        {hlrCardDetails?.activity_type_hlr_specialist_college_phone && (
          <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
            <LocalPhoneOutlinedIcon
              sx={{
                fontSize: '14px',
                mr: 1.5
              }}
            />
            <Link href={`tel: ${hlrCardDetails?.activity_type_hlr_specialist_college_phone}`}>
              {hlrCardDetails?.activity_type_hlr_specialist_college_phone}
            </Link>
          </Typography>
        )}
        {hlrCardDetails?.activity_type_hlr_specialist_college_website && (
          <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
            <InsertLinkOutlinedIcon sx={{ fontSize: '14px', mr: 1.5 }} />
            <Link
              target="_blank"
              rel="noreferrer"
              href={`${hlrCardDetails?.activity_type_hlr_specialist_college_website}`}
            >
              {hlrCardDetails?.activity_type_hlr_specialist_college_website}
            </Link>
          </Typography>
        )}
        <Box
          sx={{
            table: {
              border: 'none',
              textAlign: 'left',
              borderCollapse: 'collapse',
              width: '100% !important'
            },
            thead: {
              backgroundColor: '#D2DCE1',
              th: {
                border: 'none',
                py: 1,
                px: 2
              }
            },
            tbody: {
              border: 'none',
              tr: {
                border: 'none',
                '&:nth-child(odd)': { backgroundColor: '#F8F8F8' }
              },
              td: {
                border: 'none',
                py: 1,
                px: 2,
                verticalAlign: 'top'
              }
            }
          }}
          dangerouslySetInnerHTML={{
            __html: hlrCardDetails?.activity_type_hlr_content!
          }}
        ></Box>
      </Box>
    </>
  );
};
export { HLRContent };
